import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ReviewPeriodCustomGoalDialogComponent } from 'src/app/dialogs';
import { IResultModel, ResultModel } from 'src/app/models/general/result.model';
import { ReviewPeriodCustomGoal } from 'src/app/models/review-period-custom-goal.model';
import { GoalService } from 'src/app/services';
import { ConfirmDialogComponent, IConfirmDialogModel } from 'src/app/shared/components';
import { ActionStateModel, ListItem, SearchConfig, SearchOption } from 'src/app/shared/models';
import { ErrorMessageService } from 'src/app/shared/services';

@Component({
  selector: 'app-review-period-custom-goals',
  templateUrl: './review-period-custom-goals.component.html',
  styleUrl: './review-period-custom-goals.component.scss'
})
export class ReviewPeriodCustomGoalsComponent implements OnInit {

  public leaderText: string;
  public selfText: string;
  public assistantText: string;

  @Input()
  public items: ReviewPeriodCustomGoal[] = [];

  public actionState = {editMode: true, currentItemIndex: null} as ActionStateModel;

  public get listItems(): ListItem<ReviewPeriodCustomGoal>[] { 
    return this.items.map(x => new ListItem(x));
  }
 
  public searchConfig: SearchConfig<ReviewPeriodCustomGoal, number> = {
      mapItem: (model: ReviewPeriodCustomGoal) => {
        return {
          id: model.id, 
          text: model.name,
          dropText: `${model.name}`,
          itemSource: model } as SearchOption<ReviewPeriodCustomGoal, number>;
      },
      getList: this.goalService.getReviewPeriodCustomGoalList
    };
  
  constructor(
    private goalService: GoalService, 
    private dialog: MatDialog,
    private msgService: ErrorMessageService,
    private translate: TranslateService
  ) {
     
  }

  ngOnInit(): void 
  {
    this.translate.stream([
      'REVIEW_PERIOD_EDIT.LEADER',
      'REVIEW_PERIOD_EDIT.SELF',
      'REVIEW_PERIOD_EDIT.ASSISTANT']
    ).subscribe(translations => {
      this.leaderText = translations['REVIEW_PERIOD_EDIT.LEADER'];
      this.selfText = translations['REVIEW_PERIOD_EDIT.SELF'];
      this.assistantText = translations['REVIEW_PERIOD_EDIT.ASSISTANT'];
    });
  }

  public addCustomGoal() {

    let dialog = this.dialog.open(ReviewPeriodCustomGoalDialogComponent, {
      minWidth: "500px",      
      data: null
    });

    dialog.afterClosed().subscribe( (result: ReviewPeriodCustomGoal) => {
      if (result) {
        this.items.push(result);
      }
    });    

  }

  public editCustomGoal(index: number, item: ReviewPeriodCustomGoal) {
    
    // show dialog
    let dialogData = item;
    let dialog = this.dialog.open(ReviewPeriodCustomGoalDialogComponent, {
      minWidth: "500px",      
      data: dialogData
    });

    dialog.afterClosed().subscribe( (result: ReviewPeriodCustomGoal) => {
      if (result) {
        this.items[index] = result;
      }
    });
  }

  // remove the item from this.items by index
  public removeCustomGoal(index: number, item: ReviewPeriodCustomGoal) {
    if (index >= 0 && index < this.items.length) {
      if (item.id > 0) {

        if (item.hasData) {
          const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                maxWidth: "600px",
                data: {
                    title: 'Egyéni cél törlése',
                    htmlMessage: 'Figyelem! Az értékelőlapok már tartalmaznak adatokat ebben az értékelési mezőben.<br>Biztos vagy benne, hogy véglegesen törlöd ezt az egyéni szöveges értékelési mezőt az időszak összes értékelőlapjáról?',
                    confirmButtonConfig: {name: 'Igen, törlöm!', color: 'warn'},
                } as IConfirmDialogModel
              });
              
          dialogRef.afterClosed().subscribe( (dialogResult: boolean) => {
            if (dialogResult)
            {
              this.deleteCustomGoal(index, item.id);
            }
          });
        }
        else {
          this.deleteCustomGoal(index, item.id);
        }
      }
      else
        this.items.splice(index, 1);
    }
  }

  public deleteCustomGoal(index: number, id: number) {
    this.goalService.deleteReviewPeriodCustomGoal(id).subscribe({
      next: () => {
        this.items.splice(index, 1);
      },
      error: (err: IResultModel<ResultModel>) => {
        this.msgService.handleError<ResultModel>(err);
      }
    });
  }

  public getWhoCanEdit(item: ReviewPeriodCustomGoal): string {
    let list: string[] = [];

    if (item.isAllowChangeForLeader)
      list.push(this.leaderText);
    if (item.isAllowChangeForSelf)
      list.push(this.selfText);
    if (item.isAllowChangeForAssistant)
      list.push(this.assistantText);

    return list.join(', ');
  }

}
